import React from 'react'

import { Helmet } from 'react-helmet'

import Header from '../../components/header'
import Footer from '../../components/footer'
import Whatsapp from '../../components/whatsapp'
import './direito-do-passageiro.css'

const DireitoDoPassageiro = (props) => {
  return (
    <div className="direito-do-passageiro-container10">
      <Helmet>
        <title>
          Direito-do-Passageiro - Adv. Wanderson H Cavalari - Cuiabá
        </title>
        <meta
          name="description"
          content="Advogado em Cuiabá a mais de 10 anos, defendendo seus direitos com expertise e comprometimento."
        />
        <meta
          property="og:title"
          content="Direito-do-Passageiro - Adv. Wanderson H Cavalari - Cuiabá"
        />
        <meta
          property="og:description"
          content="Advogado em Cuiabá a mais de 10 anos, defendendo seus direitos com expertise e comprometimento."
        />
      </Helmet>
      <div className="direito-do-passageiro-container11">
        <main className="direito-do-passageiro-container12">
          <div className="direito-do-passageiro-container13">
            <Header rootClassName="headerroot-class-name18"></Header>
            <div className="direito-do-passageiro-container14">
              <div className="direito-do-passageiro-frame46">
                <span className="direito-do-passageiro-text10">
                  ÁREA DE ATUAÇÃO
                </span>
                <span className="direito-do-passageiro-text11">Direito do</span>
                <span className="direito-do-passageiro-text12">Passageiro</span>
                <span className="direito-do-passageiro-text13">
                  A advocacia especializada em direito de passageiros aéreos se
                  concentra em proteger os direitos dos viajantes em casos de
                  atrasos, cancelamentos, overbooking e bagagem perdida,
                  buscando compensações financeiras e garantindo o cumprimento
                  das normas regulatórias da aviação civil.
                </span>
              </div>
              <div className="direito-do-passageiro-container15">
                <span className="direito-do-passageiro-text14">
                  <span>Fale Comigo</span>
                </span>
                <span className="direito-do-passageiro-text16 Content">
                  Quer saber mais sobre esta área de atuação? Mande-me uma
                  mensagem para introduzirmos esta questão
                </span>
                <iframe
                  src="https://whc-dun.vercel.app/email"
                  scrolling="no"
                  className="direito-do-passageiro-iframe"
                ></iframe>
              </div>
            </div>
          </div>
          <div className="direito-do-passageiro-container16">
            <div className="direito-do-passageiro-container17">
              <div className="direito-do-passageiro-frame86">
                <div className="direito-do-passageiro-container18">
                  <img
                    alt="image"
                    src="/flight%20delay%20rights-300h.webp"
                    loading="eager"
                    className="direito-do-passageiro-image1 section_image"
                  />
                  <div className="direito-do-passageiro-container19">
                    <span className="direito-do-passageiro-text17">
                      <span>
                        Problemas com Cia aérea: Atraso de Voo, Extravio de
                        Bagagem
                      </span>
                      <br></br>
                    </span>
                    <span className="direito-do-passageiro-text20">
                      <span>
                        Quando um passageiro enfrenta problemas com uma
                        companhia aérea, como atraso de voo ou extravio de
                        bagagem, ele tem direito a buscar uma solução através de
                        diversas medidas legais.
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                      <br></br>
                      <span>
                        É importante que o passageiro reúna toda a documentação
                        relevante, como comprovantes de compra da passagem,
                        registro de ocorrência de extravio de bagagem e
                        registros de comunicação com a companhia aérea, para
                        fundamentar sua reclamação e buscar uma solução para o
                        problema enfrentado.
                      </span>
                      <br></br>
                    </span>
                  </div>
                </div>
                <div className="direito-do-passageiro-container20">
                  <img
                    alt="image"
                    src="/jus.com.br%20image-300h.webp"
                    loading="eager"
                    className="direito-do-passageiro-image2 section_image"
                  />
                  <div className="direito-do-passageiro-container21">
                    <span className="direito-do-passageiro-text25">
                      Problemas com Cia aérea em voos internacionais: Atraso de
                      Voo, Cancelamento de Voo, Extravio de Bagagem
                    </span>
                    <span className="direito-do-passageiro-text26">
                      <span>
                        Quando um passageiro enfrenta problemas com uma
                        companhia aérea em voos internacionais, como atraso de
                        voo, cancelamento de voo ou extravio de bagagem, ele
                        ainda tem direitos e pode tomar várias medidas legais
                        para buscar uma solução.
                      </span>
                      <br></br>
                      <span>
                        É importante que o passageiro reúna toda a documentação
                        relevante, como comprovantes de compra da passagem,
                        registros de comunicação com a companhia aérea e o
                        relatório de irregularidade de bagagem, para fundamentar
                        sua reclamação e buscar uma solução para o problema
                        enfrentado.
                      </span>
                      <br></br>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer rootClassName="footerroot-class-name12"></Footer>
          <Whatsapp></Whatsapp>
        </main>
      </div>
    </div>
  )
}

export default DireitoDoPassageiro
